import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthStingService} from './auth.service';
import {AuthInterceptor} from './auth.interceptor';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';


@NgModule({
    imports  : [
        HttpClientModule,
        CommonModule,
        TranslateModule
    ],
    providers: [
        AuthStingService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi   : true
        }
    ]
})
export class AuthModule
{
}
